<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'
import BaseButtonDialog from '@components/BaseButtonDialog'

import pageMixin from '@src/mixins/pagination'

import { productTypeList, productTypeFilter, prepaidCapacityFilter, priceStatusFilter } from '@utils/filter-value-to-text'
import { formatDateRange } from '@utils/format-date'
import { getSavedState } from '@utils/browser-help'


export default {
  page: {
    title: '美容服務',
    meta: [{ name: 'description', content: 'Prices List' }],
  },
  components: {
    Layout,
    BaseButtonDialog,
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  filters: {
    productTypeFilter,
    priceStatusFilter,
    prepaidCapacityFilter,
    formatDateRange,
  },
  mixins: [pageMixin],
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
    serviceCategory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      products: [...this.merchantProducts],
      category: [...this.serviceCategory],
      filterData: {
        state: '',
        productId: '',
        type: '',
      },
      productTypeList: Object.freeze(productTypeList),
      activeTab: this.$route.params.activeTab || '1',
      tabList: Object.freeze([
        {
          title: '基本設定',
          type: 'basic',
          component: () => lazyLoadComponent(import('./TabBasic')),
        },
        {
          title: '服務分類',
          type: 'category',
          component: () => lazyLoadComponent(import('./TabCategory')),
        },
        {
          title: '一般服務',
          type: 'service',
          component: () => lazyLoadComponent(import('./TabService')),
        },
        {
          title: '加購服務',
          type: 'addition',
          component: () => lazyLoadComponent(import('./TabAddition')),
        },
        {
          title: `${this.$t('service.SPA')}介紹`,
          type: 'spa',
          component: () => lazyLoadComponent(import('./TabSpa')),
        },
      ]),
      mode: '',
    }
  },
  computed: {
    pageTitle() {
      return this.mode ? (this.mode === 'add' ? `新增${this.tabList[+this.activeTab].title}` : `編輯${this.tabList[+this.activeTab].title}`) : `服務項目`
    },
  },
  watch: {
  },
  created() {
    const activeTabIndex = this.tabList.findIndex(item => item.type === this.$route.params.type)
    this.activeTab = activeTabIndex > -1 ? `${activeTabIndex}` : `0`
    if (this.$route.query.tab === 'category') {
      this.activeTab = '2'
    }
    this.filterTabList()
  },
  methods: {
    /**
     * @description 如果沒有購買servicePriceGroup -> 則spa要關掉
     */
    async filterTabList() {
      const { plan } = await getSavedState('merchant.cached')
      if (plan) {
        let permissionPriceGroup = plan.additionalModules.findIndex(item => item === 'servicePriceGroup')
        if (permissionPriceGroup === -1) {
          this.tabList = this.tabList.filter(item => item.type !== 'spa')
        }
      }
    },
    onFilterReset() {
      this.filterData = {
        state: '',
        productId: '',
      }
      this.tryToFetchList()
    },
    updateMode(mode) {
      this.mode = mode
    },
    changeTitle() {
      this.$route.meta.title = this.pageTitle
    },
    async updateCategory() {
      this.category = await this.$store.dispatch('product/fetchServiceCategory')
    }
  },
}
</script>

<template>
  <Layout>
    <el-tabs v-model="activeTab" :class="[mode !== '' ? isEdit : '']" stretch type="border-card" class="isStyleBase">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`" class="AVD">
      </el-tab-pane>
    </el-tabs>
    <div :class="$style.marginContent">
      <component :is="tabList[activeTab].component" :merchant-products="products" :service-category="category"
        @update-category="updateCategory" @update-mode="updateMode" @changeTitle="changeTitle">
      </component>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.table {
  @include layer-elevation(5);
}

.marginContent {
  margin: 20px;
}

:global {
  .isEdit {
    .el-tabs__header {
      display: none;
    }

    &.el-tabs--border-card {
      border-radius: 0;
      background: none;
      box-shadow: none;

      .el-tabs__content {
        padding: 0;
      }
    }
  }
}
</style>
